import React from "react";

const CheckboxLabel = ({ text, id, checked, onChange }) => {
  return (
    <div className="checkbox-label">
      <label
        htmlFor={id}
        className="flex flex-align-center"
      >
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
        />
        {text}
      </label>
    </div>
  );
};

export default CheckboxLabel;
